import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { DIFFERENTIALS } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

export const Differentials = () => {
  return (
    <section data-testid="differentials-section" className="border-y border-white/10 bg-[#0d0d0d] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
              / 02 — Diferenciais
            </span>
            <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              Por que a<br />K2 Guincho
            </h2>
            <p className="mt-5 max-w-sm text-base text-zinc-400">
              Estrutura completa e profissionais experientes para garantir o
              melhor atendimento na hora que você mais precisa.
            </p>
          </Reveal>

          <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
            {DIFFERENTIALS.map((d, i) => (
              <motion.div
                key={d}
                data-testid={`differential-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.05, ease: EASE }}
                className="group flex items-center gap-4 bg-[#111111] px-6 py-6 transition-colors duration-300 hover:bg-[#161616]"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-[#D50000]/40 text-[#D50000] transition-colors duration-300 group-hover:bg-[#D50000] group-hover:text-white">
                  <Check size={18} strokeWidth={2.5} />
                </span>
                <span className="font-mono-t text-xs text-zinc-500">
                  0{i + 1}
                </span>
                <span className="text-sm font-semibold uppercase tracking-wide text-white sm:text-base">
                  {d}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
